export default __webpack_public_path__ + "static/155-aed954750ed78cc1363dd9fc6fa76c23.jpg";